/**
 * Strips emojis from the event's target value.
 * Mutates the event target value directly before passing it on.
 */
export const sanitizeEmojiFromEvent = (e) => {
  const emojiRegex = /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF]|\uFE0F)/g;

  e.target.value = e.target.value.replace(emojiRegex, '');
  return e;
};
